module.exports = "/_next/static/images/0e00288c6afc84cead5819f51463397c-card-and-phone-3d-md@3x.jpg";